import { render, staticRenderFns } from "./CollectionWidget.vue?vue&type=template&id=132665b2&scoped=true"
import script from "./CollectionWidget.vue?vue&type=script&lang=js"
export * from "./CollectionWidget.vue?vue&type=script&lang=js"
import style0 from "./CollectionWidget.vue?vue&type=style&index=0&id=132665b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132665b2",
  null
  
)

export default component.exports